import React, { type ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

function DocumentsIcon(props: React.ComponentPropsWithoutRef<'svg'>): ReactNode {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      {...props}
      className={twMerge('text-background-secondary', props.className)}
    >
      <g id="Icon">
        <path
          id="Vector"
          d="M7 2.46948H16.5L21 6.96948V19.4695"
          fill="none"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M3 20.9695V6.96948C3 6.14105 3.67157 5.46948 4.5 5.46948H14.2515C14.4106 5.46948 14.5632 5.53269 14.6757 5.64522L17.8243 8.79374C17.9368 8.90627 18 9.05888 18 9.21801V20.9695C18 21.7979 17.3284 22.4695 16.5 22.4695H4.5C3.67157 22.4695 3 21.7979 3 20.9695Z"
          strokeWidth="1.5"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M14 8.86948V5.82303C14 5.62777 14.1583 5.46948 14.3536 5.46948C14.4473 5.46948 14.5372 5.50673 14.6036 5.57303L17.8964 8.86593C17.9628 8.93223 18 9.02216 18 9.11593C18 9.31119 17.8417 9.46948 17.6464 9.46948H14.6C14.2686 9.46948 14 9.20085 14 8.86948Z"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export default DocumentsIcon
